import moment from 'moment-timezone';

/**
 * When an appointment was posted - `appointments.created_at`.
 *
 * Deliberately NOT formatted the way `datetime` is formatted beside it.
 * `created_at` is a real UTC timestamp written by the database, so it has to be
 * converted to Pacific to mean anything. `datetime` is the raw wall-clock the
 * scheduler typed, stored without conversion (see CLAUDE.md section 13), which
 * is why the tables render it through a bare moment() with no timezone step.
 *
 * Running created_at through a bare moment() would read it in the browser's
 * local zone and shift every "Posted" value by the viewer's offset - the same
 * conversion the report columns and LogsTable.jsx already do correctly.
 */
export const formatPostedAt = (value) =>
    (value ? moment.utc(value).tz('America/Los_Angeles').format('MMM D, YYYY HH:mm') : 'N/A');

export default formatPostedAt;
